import { News } from "@/types/api";
import { createContext } from "react";

const NewsItemContext = createContext({} as News);

export default NewsItemContext;
